<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all LogoCenter">
    <div class="LogoCenterNav">
      <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="LogoCenterNav_list font18"
        >自由创作(<span>25</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/LetterLogoCenter" class="LogoCenterNav_list font18 active"
        >字母LOGO(<span>2</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/SameCreationCenter" class="LogoCenterNav_list font18"
        >同款创作(<span>5</span>)</router-link
      >
      <div class="LogoCenterNav_list font18">已保存(<span>77</span>)</div>
      <div class="LogoCenterNav_list font18">已下载(<span>5</span>)</div>
      <div class="LogoCenterNav_list font18">解析理念(<span>8</span>)</div>
    </div>
    <div class="LogoCenterContent">
      <div class="LogoCenterTitle">
        <div class="LogoCenterTitl_left">
          <div class="LogoCenterTitl_left_dd font24">胖达人</div>
          <div class="LogoCenterTitl_left_dt">
            <div class="left_dt_list font16">A CHUBBY PERSON</div>
            <div class="left_dt_list font16">面包、面点师</div>
            <div class="left_dt_list font16">其他-医药研发</div>
            <div class="left_dt_list font16">吉祥物</div>
            <div class="left_dt_list font16">蓝色</div>
          </div>
        </div>
        <div class="LogoCenterTitl_again font16" @click="toggleClass">
          <img alt="" src="@a/ailogo/images/sv4.svg" />再来一批
        </div>
      </div>
      <div class="LogoCenterContent_logo OScroll">
        <div class="LogoCenterContent_logo_list">
          <div class="logo_list_img"><img alt="" src="@a/ailogo/images/bg11.jpg" /></div>
          <div class="logo_list_btn">
            <router-link to="/ailogo/GenerateManagement/LogoFile" class="list_btn_li font14"
              ><img alt="" src="@a/ailogo/images/sv1.svg" />VI资产</router-link
            >
            <div class="list_btn_li font14">
              <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
            </div>
            <div class="list_btn_li font14"><img alt="" src="@a/ailogo/images/sv3.svg" />下载</div>
          </div>
        </div>
        <div class="LogoCenterContent_logo_list">
          <div class="logo_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg" /></div>
          <div class="logo_list_btn">
            <router-link to="/ailogo/GenerateManagement/LogoFile" class="list_btn_li font14"
              ><img alt="" src="@a/ailogo/images/sv1.svg" />VI资产</router-link
            >
            <div class="list_btn_li font14">
              <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
            </div>
            <div class="list_btn_li font14"><img alt="" src="@a/ailogo/images/sv3.svg" />下载</div>
          </div>
        </div>
      </div>

      <div class="LogoCenterWindow" :class="{ active: isActive }">
        <div class="LogoCenterWindow_bg">
          <div class="LogoCenterWindowContent">
            <div class="LogoCenterWindow_title">
              <div class="LogoCenterWindow_title_left font20">请调整生成信息再来一批吧</div>
              <div class="LogoCenterWindow_title_btn" @click="toggleClass">
                <img alt="" src="@a/ailogo/images/sv5.svg" />
              </div>
            </div>

            <!-- Brand Information -->
            <div class="LogoCenterWindow_list LogoCenterWindow_brand">
              <div class="LogoCenterWindow_list_title font16">品牌信息</div>
              <div class="LogoCenterWindow_brand_content">
                <div
                  class="brand_content_list"
                  :class="{ active: isInputFocused(index), active2: isInputWithContent(index) }"
                  v-for="(item, index) in brandInputs"
                  :key="index"
                >
                  <input
                    type="text"
                    placeholder=""
                    class="font14"
                    @focus="handleFocus(index)"
                    @blur="handleBlur(index)"
                    v-model="item.value"
                  />
                  <div class="content_list_title font14">
                    {{ index === 0 ? '品牌名称（20个字内）' : '品牌英文名称或口号（选填）' }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Logo -->
            <div class="LogoCenterWindow_list LogoCenterWindow_logo">
              <div class="LogoCenterWindow_list_title font16">LOGO使用的字母</div>
              <div class="LogoCenterWindow_logo_content">
                <div
                  v-for="(letter, index) in letters"
                  :key="index"
                  :class="['logo_content_list', 'font16', { active: activeIndex === index }]"
                  @click="selectLetter(index)"
                >
                  {{ letter }}
                </div>
              </div>
            </div>

            <!-- Industry -->
            <div
              class="LogoCenterWindow_list LogoCenterWindow_industry LogoCenterWindow_industryst"
            >
              <div class="LogoCenterWindow_list_title font16">行业</div>
              <div class="LogoCenterWindow_industry_content">
                <div
                  class="industry_content_list font12"
                  :class="{ active: activeIndustry === index }"
                  v-for="(item, index) in industries"
                  :key="index"
                  @click="selectIndustry(index)"
                >
                  {{ item }}
                </div>
              </div>
            </div>

            <!-- Keyword -->
            <div class="LogoCenterWindow_flex">
              <div class="LogoCenterWindow_list LogoCenterWindow_keyword">
                <div class="LogoCenterWindow_list_title">
                  <div class="list_title_left font16">品牌关键词</div>
                  <div class="list_title_btn font14" @click="ExampleWindowClass">
                    更多示例<img alt="" src="@a/ailogo/images/sv6.svg" />
                  </div>
                </div>
                <div class="LogoCenterWindow_keyword_content">
                  <textarea
                    class="font14"
                    placeholder="请输入您想在LOGO中看到的元素，建议输入3个及以上的关键 比如“龙游车行”可以输入: 跑车，龙，环形等..."
                    v-model="keywordInput"
                    @input="updateCharCount"
                    maxlength="150"
                  ></textarea>
                  <div class="keyword_content_btn font14">
                    <div class="content_btn_lists font14">{{ charCount }}</div>
                    /
                    <div class="content_btn_list font14">150</div>
                    <div class="content_btn_icon"></div>
                    <div class="content_btn_right font14" @click="clearInput">
                      <span class="iconfont icon-a-qingkong1 font14"></span>清空
                    </div>
                  </div>
                </div>
              </div>

              <!-- Keyword2 -->
              <div class="LogoCenterWindow_list LogoCenterWindow_keyword2">
                <div class="LogoCenterWindow_list_title font16">
                  想不好关键词？来试试让AI帮您生成关键词
                </div>
                <div class="LogoCenterWindow_keyword2_content">
                  <div class="keyword2_content_search">
                    <input type="text" placeholder="请输入一句描述语" class="font14" />
                    <div class="content_search_btn font14">提交</div>
                  </div>
                  <div class="keyword2_content_txt">
                    <div
                      class="content_txt_list font12"
                      :class="{ active: activeKeywords.includes(item) }"
                      v-for="(item, index) in keywords"
                      :key="index"
                      @click="toggleKeyword(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Color -->
            <div class="LogoCenterWindow_list LogoCenterWindow_Color">
              <div class="LogoCenterWindow_list_title font16">颜色</div>
              <div class="LogoCenterWindow_Color_content">
                <div
                  class="Color_content_list"
                  :class="{ active: activeColor === index }"
                  v-for="(color, index) in colors"
                  :key="index"
                  @click="selectColor(index)"
                ></div>
                <div class="Color_content_other">
                  <div class="StyleColor_bottomcolor" :class="{ active: otherColorInput }">
                    <div class="StyleColor_bottomcolor_left font14"><span></span>其他：</div>
                    <div class="StyleColor_bottomcolor_right">
                      <input
                        type="text"
                        placeholder="请输入您喜欢的颜色（例如：棕色）"
                        class="font14"
                        v-model="otherColorInput"
                        @input="handleOtherColorInput"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Generate -->
            <div class="LogoCenterWindow_generate">
              <div class="LogoCenterWindow_generate_left font16">剩余生成次数：<span>21</span></div>
              <div class="LogoCenterWindow_generate_Recharge font16">
                充值<img alt="" src="@a/ailogo/images/sv6.svg" />
              </div>
              <div class="LogoCenterWindow_generate_btn">立即生成</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ExampleWindow" :class="{ active: ExampleWindowActive }">
        <div class="ExampleWindow_content">
          <div class="ExampleWindow_content_title">
            <div class="content_title_left font20">关键词示例</div>
            <div class="content_title_click" @click="ExampleWindowClass">
              <img alt="" src="@a/ailogo/images/sv5.svg" />
            </div>
          </div>
          <div class="ExampleWindow_content_txt">
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg8.jpg" /></div>
              <div class="txt_list_title font16">竹子，篮子，新鲜的</div>
            </div>
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg9.jpg" /></div>
              <div class="txt_list_title font16">萌芽，女孩侧影，圆形，文艺的</div>
            </div>
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg10.jpg" /></div>
              <div class="txt_list_title font16">农产品，农民，阳光的</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
export default {
  data() {
    return {
      isActive: false,
      ExampleWindowActive: false,
      brandInputs: [
        { value: '', focused: false },
        { value: '', focused: false }
      ],
      industries: [
        '餐饮美食',
        '美容美发',
        '健康养生',
        '教育培训',
        '文体娱乐',
        '母婴保育',
        '箱包服饰',
        '家居建材',
        '萌宠服务',
        '商品零售',
        '旅游住宿',
        '汽车服务',
        '房地产',
        '科研服务',
        '生产制造',
        '企业服务',
        '农业服务',
        '公益环保',
        '政务组织',
        '生活服务'
      ],
      activeIndustry: 0,
      keywordInput: '',
      charCount: 0,
      keywords: ['老鼠', '染色体', '药物', '科研', '试用药', 'DNA'],
      activeKeywords: [], // Array to hold active keywords
      activeStyle: 0,
      colors: ['red', 'blue', 'green', 'blue', 'green', 'blue', 'green'],
      activeColor: null,
      otherColorInput: '',
      letters: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      activeIndex: null // To track which letter is active
    }
  },
  components: {
    Header
  },
  methods: {
    selectLetter(index) {
      this.activeIndex = index // Update the active index
    },
    toggleClass() {
      this.isActive = !this.isActive
    },
    ExampleWindowClass() {
      this.ExampleWindowActive = !this.ExampleWindowActive
    },
    handleFocus(index) {
      this.brandInputs[index].focused = true
    },
    handleBlur(index) {
      this.brandInputs[index].focused = false
    },
    isInputFocused(index) {
      return this.brandInputs[index].focused
    },
    isInputWithContent(index) {
      return this.brandInputs[index].value.trim() !== ''
    },
    updateCharCount() {
      this.charCount = this.keywordInput.length
      if (this.charCount > 150) {
        this.keywordInput = this.keywordInput.slice(0, 150)
      }
    },
    clearInput() {
      this.keywordInput = ''
      this.charCount = 0
      this.activeKeywords = [] // Clear all active keywords
    },
    toggleKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      if (keywordIndex !== -1) {
        // Remove item from textarea
        this.removeKeyword(item)
      } else {
        // Add item to textarea
        this.addKeyword(item)
      }

      // Update charCount after the change
      this.updateCharCount()
    },
    addKeyword(item) {
      if (this.keywordInput) {
        this.keywordInput += `, ${item}`
      } else {
        this.keywordInput = item
      }
      this.activeKeywords.push(item)
    },
    removeKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      keywordsArray.splice(keywordIndex, 1)
      this.keywordInput = keywordsArray.join(', ')
      this.activeKeywords = this.activeKeywords.filter((keyword) => keyword !== item)
    },
    selectIndustry(index) {
      this.activeIndustry = index
    },
    selectColor(index) {
      this.activeColor = index
      this.otherColorInput = '' // Clear other color input if any color is selected
    },
    handleOtherColorInput() {
      if (this.otherColorInput) {
        this.activeColor = null
      }
    }
  }
}
</script>


<style>
@import "LogoCenter.css";
</style>
